// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"partnership-page_badgeContainer__RlmrB","badge":"partnership-page_badge__AhnjM","badgeAnimation":"partnership-page_badgeAnimation__1RqG_"};